import {graphql} from "react-apollo";
import {Map} from "immutable";
import React, {useEffect, useState} from "react";
import {LIST_ACTIVE_JOBS, ON_NEW_JOB, ON_UPDATED_JOB} from "../../../queries/warehouseJobs";
import {getWarehouseIdFromParam, PACKAGE_STATES, withWarehousePackages} from "../../../lib/WarehouseHelper";
import DueToProcessPanel from "./_1_DueToProcessPanel";
import PickPanel from "./_2_PickPanel";
import PackPanel from "./_3_PackPanel";
import PickupReadyPanel from "./_4_PickupReadyPanel";
import InTransitPanel from "./_5_InTransitPanel";
import {connect} from "react-redux";
import {addJob, updateJob} from "../../../actions/WarehousePackageActions";


const WarehouseDashboard = (props) => {
  const { warehouseId, warehousePackages } = props;
  const [dueToProcessPackages, setDueToProcessPackages] = useState(Map());
  const [pickPackages, setPickPackages] = useState(Map());
  const [packPackages, setPackPackages] = useState(Map());
  const [pickupReadyPackages, setPickupReadyPackages] = useState(Map());
  const [inTransitPackages, setInTransitPackages] = useState(Map());

  useEffect(() => {
    if (warehouseId && props.data) {
      const unsubscribeToUpdates = props.subscribeToUpdates(props);
      const unsubscribeToNews = props.subscribeToNews(props);

      return () => unsubscribeToUpdates() && unsubscribeToNews();
    }
  }, [warehouseId]);

  useEffect(() => {
    if (warehousePackages && warehousePackages.size > 0) {
      // Track updates to packages status (update only when necessary)
      const dtp = warehousePackages.filter((p) => p.get("state") === PACKAGE_STATES.DUE_TO_PROCESS);
      if (dtp.toJS() !== dueToProcessPackages.toJS()) {
        setDueToProcessPackages(dtp);
      }
      const pick = warehousePackages.filter((p) => p.get("state") === PACKAGE_STATES.PICK);
      if (pick.toJS() !== pickPackages.toJS()) {
        setPickPackages(pick);
      }
      const pack = warehousePackages.filter((p) => p.get("state") === PACKAGE_STATES.PACK);
      if (pack.toJS() !== packPackages.toJS()) {
        setPackPackages(pack);
      }
      const pr = warehousePackages.filter((p) => p.get("state") === PACKAGE_STATES.PICKUP_READY);
      if (pr.toJS() !== pickupReadyPackages.toJS()) {
        setPickupReadyPackages(pr);
      }
      const it = warehousePackages.filter((p) => p.get("state") === PACKAGE_STATES.IN_TRANSIT);
      if (it.toJS() !== inTransitPackages.toJS()) {
        setInTransitPackages(it);
      }
    } else {
      // Reset
      setDueToProcessPackages(Map());
      setPickPackages(Map());
      setPackPackages(Map());
      setPickupReadyPackages(Map());
      setInTransitPackages(Map());
    }
  }, [warehousePackages])


  return (
    <React.Fragment>
      <DueToProcessPanel warehouseId={warehouseId} packages={dueToProcessPackages} />
      <PickPanel warehouseId={warehouseId} packages={pickPackages} />
      <PackPanel warehouseId={warehouseId} packages={packPackages} />
      <PickupReadyPanel warehouseId={warehouseId} packages={pickupReadyPackages} />
      <InTransitPanel warehouseId={warehouseId} packages={inTransitPackages} />
    </React.Fragment>
  );
}

const mapDispatchToProps = dispatch => ({
  subscribeToUpdates: (props, params) => {
    return props.data.subscribeToMore({
      document: ON_UPDATED_JOB,
      variables: {
        warehouseId: props.warehouseId
      },
      updateQuery: (prevStartedJobs, {subscriptionData: { data: { updatedJob }}}) => {
        // No need to rerun the query as the reducer will update the job with this data
        dispatch(updateJob(props.warehouseId, updatedJob));

        return prevStartedJobs;
      }
    })
  },
  subscribeToNews: (props, params) => {
    return props.data.subscribeToMore({
      document: ON_NEW_JOB,
      variables: {
        warehouseId: props.warehouseId
      },
      updateQuery: (prevStartedJobs, {subscriptionData: { data: { newJob }}}) => {
        // No need to rerun the query as the reducer will add this job directly
        dispatch(addJob(props.warehouseId, newJob));

        return prevStartedJobs;
      }
    })
  }
});

const withSubscription = connect(null, mapDispatchToProps);

const withQuery = graphql(LIST_ACTIVE_JOBS, {
  skip: (props) => !props.warehouse,
  options: (props) => ({
    fetchPolicy: "network-only",
    variables: {
      warehouseId: getWarehouseIdFromParam(props.warehouse),
    }
  })
});

export default withQuery(withSubscription(withWarehousePackages(WarehouseDashboard)));


export function isJobLate(prepDate) {
  const preparationDueDate = new Date(prepDate);
  const today = new Date(new Date().setHours(0)); // prepDate doesn't have a time

  return today > preparationDueDate;
}
